module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('div', {
    staticClass: "project-header",
    style: (_vm.header_cls)
  }, [_c('div', {
    staticClass: "pretitle"
  }, [_vm._v("\n      Kunde\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.client.name))])]), _vm._v(" "), _c('div', {
    staticClass: "filterbtns"
  }, [_c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'projects_active'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('projects_active')
      }
    }
  }, [_vm._v("Aktive opgaver")]), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'projects'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('projects')
      }
    }
  }, [_vm._v("Alle opgaver")]), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'details'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('details')
      }
    }
  }, [_vm._v("Detaljer")]), _vm._v(" "), (_vm.economy_access) ? _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'economy'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('economy')
      }
    }
  }, [_vm._v("Økonomi")]) : _vm._e(), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'comments'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('comments')
      }
    }
  }, [_vm._v(_vm._s(_vm.getCommentsCount('client', _vm.client['.key'])) + " kommentarer")]), _vm._v(" "), _c('filterbtn', {
    attrs: {
      "active": _vm.showing == 'settings'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setShowing('settings')
      }
    }
  }, [_vm._v("Indstillinger")])], 1), _vm._v(" "), (_vm.client && _vm.showing == 'settings') ? _c('box', [_c('inputfield', {
    attrs: {
      "label": "Navn"
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.client.name
    },
    on: {
      "change": function($event) {
        return _vm.change('name', $event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Farve"
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.client.color
    },
    on: {
      "change": function($event) {
        return _vm.change('color', $event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Timepris (Kan også projektdefineres)"
    }
  }, [_c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.client.hour_rate
    },
    on: {
      "change": function($event) {
        return _vm.change('hour_rate', $event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Tags"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.tags),
      expression: "client.tags"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.tags)
    },
    on: {
      "change": function($event) {
        return _vm.change('tags', $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "tags", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "Background image tags (commasep eg: nature,water)"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.bgimg_tags),
      expression: "client.bgimg_tags"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.bgimg_tags)
    },
    on: {
      "change": function($event) {
        return _vm.change('bgimg_tags', $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "bgimg_tags", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('inputfield', {
    attrs: {
      "label": "CVR nummer"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.cvr),
      expression: "client.cvr"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.cvr)
    },
    on: {
      "change": function($event) {
        return _vm.change('cvr', $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "cvr", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "2"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitChanges()
      }
    }
  }, [_vm._v("Gem")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.archiveClient()
      }
    }
  }, [_vm._v("Arkivér kunde")])], 1) : _vm._e(), _vm._v(" "), (_vm.economy_access && _vm.showing == 'economy') ? _c('box', {
    attrs: {
      "label": "Økonomiposter"
    }
  }, [_c('economy-posts', {
    attrs: {
      "posts": _vm.economyposts.posts,
      "totals": _vm.economyposts.totals,
      "fields": "title,client,project,invoice_no,invoice_date,invoiced,paid,amount"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.economy_access && _vm.showing == 'economy') ? _c('box', {
    attrs: {
      "label": "Dinero faktura-oversigt"
    }
  }, [(!_vm.$store.state.dinero_fetched) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.dinero_fetch_invoices()
      }
    }
  }, [_vm._v("Indlæs Dinero fakturaer")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.dinero_fetched && _vm.client_dinero_invoices) ? _c('dinero-invoices', {
    attrs: {
      "invoices": _vm.client_dinero_invoices
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showing == 'details') ? _c('box', {
    attrs: {
      "label": "Detaljer"
    }
  }, [_c('table', {
    staticClass: "table-a"
  }, [_c('tr', [_c('td', [_vm._v("Kundens timepris")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(_vm.client.hour_rate, 2)) + " kr.")])]), _vm._v(" "), (_vm.economy_access) ? _c('tr', [_c('td', [_vm._v("Indtjening i alt")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(_vm.client_total_earning, 2)) + " kr.")])]) : _vm._e(), _vm._v(" "), (_vm.economy_access) ? _c('tr', [_c('td', [_vm._v("Faktureret i alt (Dinero)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(_vm.client_dinero_invoiced_total, 2)) + " kr.")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("timer tracket i alt")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("decimals")(_vm.client_timelog_totals, 2)) + " timer")])]), _vm._v(" "), (_vm.economy_access) ? _c('tr', [_c('td', [_vm._v("Reel timepris")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm._f("money")(_vm.client_total_earning / _vm.client_timelog_totals, 2)) + " kr.\n          ")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Kunde oprettet")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(_vm.client.created, 'DD/MM-YYYY HH:MM')) + " ")])])])]) : _vm._e(), _vm._v(" "), (_vm.showing == 'projects_active') ? _c('box', {
    attrs: {
      "label": _vm.clientActiveProjects.length + ' opgaver'
    }
  }, [_c('table', {
    staticClass: "table-a projects-table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th', [_vm._v("Budget")]), _vm._v(" "), _c('th', [_vm._v("Estimeret")]), _vm._v(" "), _c('th', [_vm._v("Tracket")]), _vm._v(" "), _c('th', [_vm._v("Tidsforbrug")]), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.clientActiveProjects), function(project, i) {
    return _c('tr', {
      key: 'fadsfd' + i
    }, [_c('td', [_c('avatar', {
      attrs: {
        "input": project
      }
    })], 1), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/project/' + project['.key']
      }
    }, [_vm._v(_vm._s(project.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("fallback2")(_vm._f("money")(project.budget, 0), 0)) + " kr.")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("fallback2")(project.estimated_hrs, 0)) + " T")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("fallback2")(_vm._f("decimals")(project.timelogs_total_hours, 2), 0)) + " T")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(project.budgetted_hours_spent_pct) + " %")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "timelog-play-btn",
      on: {
        "click": function($event) {
          return _vm.openTimeloggerBasic({
            project_key: project['.key']
          })
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "ionicons/ios-play"
      }
    })], 1)])])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('btn', {
    staticClass: "hide",
    nativeOn: {
      "click": function($event) {
        return _vm.createNewClientProject({
          status: 'active'
        })
      }
    }
  }, [_vm._v("Opret ny opgave")])], 1) : _vm._e(), _vm._v(" "), (_vm.showing == 'projects') ? _c('box', {
    attrs: {
      "label": _vm.clientProjects.length + ' opgaver'
    }
  }, [_c('table', {
    staticClass: "table-a projects-table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Budget")]), _vm._v(" "), (false) ? _c('th', [_vm._v("Estimeret")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Tracket")]), _vm._v(" "), _c('th', [_vm._v("Tidsforbrug")]), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.clientProjects), function(project, i) {
    return _c('tr', {
      key: 'fadsfd' + i
    }, [_c('td', [_c('avatar', {
      attrs: {
        "input": project
      }
    })], 1), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/project/' + project['.key']
      }
    }, [_vm._v(_vm._s(project.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(project.status_translated))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("fallback2")(_vm._f("money")(project.budget, 0), 0)) + " kr.")]), _vm._v(" "), (false) ? _c('td', [_vm._v(_vm._s(_vm._f("fallback2")(project.estimated_hrs, 0)) + " T")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("fallback2")(_vm._f("decimals")(project.timelogs_total_hours, 2), 0)) + " T")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(project.budgetted_hours_spent_pct) + " %")]), _vm._v(" "), _c('td', [(project.status != 'finished') ? _c('div', {
      staticClass: "timelog-play-btn",
      on: {
        "click": function($event) {
          return _vm.openTimeloggerBasic({
            project_key: project['.key']
          })
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "ionicons/ios-play"
      }
    })], 1) : _vm._e()])])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('btn', {
    staticClass: "hide",
    nativeOn: {
      "click": function($event) {
        return _vm.createNewClientProject()
      }
    }
  }, [_vm._v("Opret ny opgave")])], 1) : _vm._e(), _vm._v(" "), (_vm.showing == 'comments') ? _c('box', {
    attrs: {
      "label": 'Kommentarer'
    }
  }, [_c('comments', {
    attrs: {
      "keytype": 'client',
      "keyis": _vm.client['.key']
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.show_debug_data_boxes) ? _c('box', {
    attrs: {
      "label": "client"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.client))])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca084bc6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Client.vue
// module id = 623
// module chunks = 1